function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_152",
  "data-name": "Path 152",
  d: "M58.242,3H45.494a17,17,0,0,0-17,17v4.249H49.743a4.249,4.249,0,1,1,0,8.5H20a17,17,0,0,0-17,17v17a17,17,0,0,0,17,17h4.249V62.491A12.764,12.764,0,0,1,37,49.743h34a4.251,4.251,0,0,0,4.249-4.249V20A17,17,0,0,0,58.242,3Zm-17,17a4.249,4.249,0,1,1,4.249-4.249A4.251,4.251,0,0,1,41.244,20Z",
  transform: "translate(-3 -3)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_153",
  "data-name": "Path 153",
  d: "M65.242,8H60.993V29.247A12.764,12.764,0,0,1,48.244,42h-34A4.251,4.251,0,0,0,10,46.244v25.5a17,17,0,0,0,17,17H39.746a17,17,0,0,0,17-17V67.491H35.5a4.249,4.249,0,0,1,0-8.5H65.242a17,17,0,0,0,17-17V25A17,17,0,0,0,65.242,8ZM44,71.741a4.249,4.249,0,1,1-4.249,4.249A4.251,4.251,0,0,1,44,71.741Z",
  transform: "translate(19.746 13.247)"
});

function SvgPython(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons8-python",
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.985,
    height: 101.985,
    viewBox: "0 0 101.985 101.985",
    transform: "translate(0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/Python.2e7cfc8a.svg";
export { ForwardRef as ReactComponent };